import * as React from "react";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSelectBar from "../Gen/SelectBar";

import DocumentListControls from "../Document/ListControls";

import { documentDisplayTitle } from "../../src/document_display_title";

interface DocumentSetDocumentRelationCreateSelectListProps {
  document_set_id: number;
  documents: ConnectedList<DocumentSnakeModel>;
}

function DocumentSetDocumentRelationCreateSelectList(props: DocumentSetDocumentRelationCreateSelectListProps) {
  const {
    document_set_id,
    documents,
  } = props;

  React.useEffect(() => {
    documents.mountList(`/document_sets/${document_set_id}/document_set_document_relations/new_batch_list`);
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSubmitButton = React.useCallback(() => {
    if (documents.selected.length === 0) {
      alert("Nothing Selected! You must select at least one member to add.");
      return;
    }

    const data = {documentIds: documents.selected.map((document) => document.id)};

    setIsSubmitLoading(true);

    fetch(`/document_sets/${document_set_id}/document_set_document_relations/create_batch_list`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response`); }

        return response.json();
      })
      .then(Turbo.visit(`/document_sets/${document_set_id}`))
      .catch(() => {
        setIsSubmitLoading(false);
      });
  }, [document_set_id, documents.selected]);

  return(
    <div>
      <div className="submit-panel">
        <h1>Add Cases To Course</h1>
        <GenButton
          name="Add"
          highlighted
          loading={isSubmitLoading}
          onClick={handleSubmitButton}
        />
      </div>
      <GenSelectBar
        {...documents}
        itemType="member(s)"
      />
      <DocumentListControls
        documents={documents}
      />
      <GenListDisplay
        {...documents}
        renderItem={(document) => <span>{documentDisplayTitle(document)}</span>}
      />
      <GenMore
        {...documents}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(DocumentSetDocumentRelationCreateSelectList, ["documents"]);
